import * as React from "react";
import { Open16Regular } from "@fluentui/react-icons";
import { ILookupDictionary } from "../../../lookup/types/ILookupDictionary";
import { WORK_NAME_LOOKUP } from "../../../lookup/Consts";
import { getLookupValues } from "../../../lookup/services/LookupHelpers";
import {
  TITLE_STATE_KEY,
  IP_NAME_NUMBER_STATE_KEY,
  SEARCH_VIEW_WORKS,
  SEARCH_VIEW_AGREEMENTS,
  SEARCH_VIEW_IPS,
  UPDATE_ACTION_STATE_KEY,
  SEARCH_VIEW_PRODUCTS,
  PRODUCT_SEARCH_TYPE_STATE_KEY,
  SEARCH_VIEW_WORKFLOW,
  SEARCH_VIEW_ARTISTS,
  TYPE_STATE_KEY,
  SEARCH_VIEW_POOLS,
  SEARCH_VIEW_DISTRIBUTIONS,
  POOL_LICENSEE_ID_STATE_KEY,
  DISTRIBUTION_ID_STATE_KEY,
  SEARCH_VIEW_ADJUSTMENTS,
  ADJUSTMENT_ID_STATE_KEY,
  DISTRIBUTION_CLAIMS_FROM_STATE_KEY,
  DISTRIBUTION_CLAIMS_TO_STATE_KEY,
  DISTRIBUTION_DATE_STATE_KEY,
  DISTRIBUTION_USAGE_FROM_STATE_KEY,
  DISTRIBUTION_USAGE_TO_STATE_KEY,
  SEARCH_VIEW_PAYMENTRUN,
  PAYMENTRUN_CODE_STATE_KEY,
  PAYMENTRUN_PAYMENTRUN_DATE_STATE_KEY,
  SEARCH_VIEW_LICENSES,
  LICENSE_ID_STATE_KEY,
  SEARCH_VIEW_CLAIMS,
  CLAIM_CODE_STATE_KEY,
  POOL_POOL_CODE_STATE_KEY,
  DISTRIBUTION_CODE_STATE_KEY,
  INTRAY,
  ADJUSTMENT_DATE_STATE_KEY,
  USAGE_GROUP_DISTRIBUTION_DATE_STATE_KEY,
  AGREEMENT_LAST_MODIFIED_DATE_STATE_KEY,
  IP_EFFECTIVE_FROM_KEY,
  IP_EFFECTIVE_TO_KEY,
  ADD_TO_PACKAGE_ACTION,
  REGION_STATE_KEY,
  PRODUCT_SEARCH_MUSIC_DURATION_KEY,
} from "../../Consts";
import { RepertoireHelper } from "../../services/RepertoireHelper";
import { DRAFT_WORKS_RESULTS_TITLE_STATE_KEY, SEARCH_VIEW_DRAFT_SET_LISTS, SEARCH_VIEW_DRAFT_WORKS, SEARCH_VIEW_LIVE_PERFORMANCE_SUBMISSION, SEARCH_VIEW_REGISTERED_CUE_SHEETS } from "../../../membersportal/Consts";
import { ILicenseInputItem } from "../../../redux/types/ILicenseInputItem";
import { FormatFields } from "../../../redux/types/FormatFields";
import DateDisplay, { YEAR_DAY_MONTH_DATE_FORMAT } from "../dateDisplay/DateDisplay";
import { DataSource } from "../../types/DataSource";
import { EntityType } from "../../types/EntityType";
import { convertSecondsToTimeStamp } from "../../../util/tools";
import IRepertoireComponentDataItem from "../../../redux/types/IRepertoireComponentDataItem";
import { EXTERNAL_BLACK_SVG, EXTERNAL_SVG, RIGHT_ARROW_SVG } from "../../IconConsts";
import { KODA_CUSTOMER_NAME, POLARIS_CUSTOMER_NAME, SPANISH_POINT_CUSTOMER_NAME, TEOSTO_CUSTOMER_NAME, TONO_CUSTOMER_NAME } from "../../../home/Consts";
import AddToPackageButton from "../addToPackageButton/AddToPackageButton";
import { isAddToPackageDisabled } from "../addToPackageButton/AddToPackagePermissions";
import { IAddtoPackageResult } from "../../types/IAddtoPackageResult";

export interface ISearchResultsTableSectionProps {
    tableContentItem: any;
    objectKey: string;
    index?: number;
    getWorkDetails?: (dataSource: string, workID) => void;
    getAgreementDetails?: (dataSource: string, agreementID) => void;
    getIPDetails?: (ipBaseNumber?: string, accountNumbeR?: string) => void;
    getProductDetails?: (dataSource: string, productCoreID: number, isForWorkflowSession?: boolean, openNewTab?: boolean, id1?: string, id2?: string, type?: string, originOfRevision?: string, productionType?: string, musicDuration?: number[], productionCategory?: string) => void;
    getArtistDetails?: (performerID: number) => void;
    getUsagePoolDetails?: (poolId: number) => void;
    lookupValues?: ILookupDictionary
    getDistributionDetails?: (distributionID: number, lookupValues: ILookupDictionary) => void;
    componentInstance: string;
    expanded?: boolean;
    expandResult?: (result: number) => void;
    renderExpandRow?: boolean;
    getUsageDetails?: (usageID: string) => void;
    getAdjustmentDetails?: (adjustmentId: string) => void;
    getPaymentRunDetails?: (paymentRunID: number, lookupValues: ILookupDictionary) => void;
    getLicenseDetails?: (licenseID: number, lookupValues: ILookupDictionary, licenseRequestWorkParameterFields: ILicenseInputItem[]) => void;
    getDraftWorkDetails?: (dataSource: string, workId: number) => void;
    getDraftSetListDetails?: (dataSource: string, productCoreId: number) => void;
    getCueSheetsDetails?: (dataSource: string, productCoreId: number) => void;
    getMemberStatementDetails?: (paymentID: string, lookupValues: ILookupDictionary, formats?: FormatFields[]) => void;
    getLivePerformanceDetails?: (usageId: string) => void;
    getClaimDetails?: (claimID: number, lookupValues: ILookupDictionary) => void;
    roles?: string[];
    addToPackages?: (userName: string, entityType: string, entityIds: number[]) => Promise<IAddtoPackageResult> | IAddtoPackageResult;
    removeFromPackages?: (userName: string, entityType: string, entityIds: number[]) => Promise<IAddtoPackageResult> | IAddtoPackageResult;
    currentUser?: string;
    resultPageData?:IRepertoireComponentDataItem,
    customer?:string;
    packageActionsDisabled?: boolean;
}

export default class SearchResultsTableSection extends React.PureComponent<
    ISearchResultsTableSectionProps
> {

    onClickExternalIcon = () => {
        const {
            getWorkDetails,
            getAgreementDetails,
            getIPDetails,
            getProductDetails,
            getArtistDetails,
            lookupValues,
            getUsagePoolDetails,
            getDistributionDetails,
            componentInstance,
            tableContentItem: { id1, id2, type, originOfRevision, entityType, dataSource, workID, agreementID, ipBaseNumber, accountNumber, productCoreID, performerID, entityID, setType, poolId, distributionID, id, paymentRunID, shoppingCartID, claimID, productionType, musicDuration, productionCategory },
            getUsageDetails,
            getAdjustmentDetails,
            getPaymentRunDetails,
            getLicenseDetails,
            getDraftSetListDetails,
            getCueSheetsDetails,
            getDraftWorkDetails,
            getLivePerformanceDetails,
            getClaimDetails
        } = this.props;

        switch (componentInstance) {
            case SEARCH_VIEW_WORKS:
                getWorkDetails(dataSource, workID)
                break;
            case SEARCH_VIEW_AGREEMENTS:
                getAgreementDetails(dataSource, agreementID)
                break;
            case SEARCH_VIEW_IPS:
                getIPDetails(ipBaseNumber, accountNumber)
                break;
            case SEARCH_VIEW_PRODUCTS:
                getProductDetails(dataSource, productCoreID, false, false, id1, id2, type, originOfRevision, productionType, musicDuration, productionCategory)
                break;
            case SEARCH_VIEW_WORKFLOW:
                if (entityType == "Usage (Work Based)" || entityType == "Usage (Product Based)" || entityType == "Usage (Live Performance)" || entityType == "Usage (Unidentified Performance)")
                    getUsageDetails(entityID);
                else if (entityType === "Intray Product")
                    getProductDetails(setType, entityID);
                else if (entityType === "Intray Agreement")
                    getAgreementDetails(INTRAY, entityID);
                else if (entityType === "Adjustment")
                    getAdjustmentDetails(entityID);
                else
                    getWorkDetails(setType, entityID);
                break;
            case SEARCH_VIEW_ARTISTS:
                getArtistDetails(performerID);
                break;
            case SEARCH_VIEW_POOLS:
                getUsagePoolDetails(poolId);
                break;
            case SEARCH_VIEW_DISTRIBUTIONS:
                getDistributionDetails(distributionID, lookupValues);
                break;
            case SEARCH_VIEW_ADJUSTMENTS:
                getAdjustmentDetails(id);
                break
            case SEARCH_VIEW_PAYMENTRUN:
                getPaymentRunDetails(paymentRunID, lookupValues);
                break
            case SEARCH_VIEW_LICENSES:
                getLicenseDetails(shoppingCartID, lookupValues, []);
                break
            case SEARCH_VIEW_DRAFT_WORKS:
                getDraftWorkDetails(dataSource, workID);
                break
            case SEARCH_VIEW_DRAFT_SET_LISTS:
                getDraftSetListDetails(dataSource, productCoreID);
                break;
            case SEARCH_VIEW_REGISTERED_CUE_SHEETS:
                getCueSheetsDetails(dataSource, productCoreID);
                break;
            case SEARCH_VIEW_LIVE_PERFORMANCE_SUBMISSION:
                getLivePerformanceDetails(id)
                break;
            case SEARCH_VIEW_CLAIMS:
                getClaimDetails(claimID, lookupValues);
                break;
            default:
                break;
        }
    };

    renderMultipleTitlesDiv = (array: string[], objectKey?: string) => {
        return (
            <div className="multipleTitlesDiv">
                {array.map((item, index) => (
                    <>
                        {(objectKey === TITLE_STATE_KEY && item) ? <div key={index}>
                            <a onClick={this.onClickExternalIcon}>
                                <div>
                                    {item}
                                    {index + 1 !== array.length ? <span>,</span> : null}
                                </div>
                            </a>

                        </div> : <>
                            <div key={index}>
                                <div>
                                    {item}
                                    {index + 1 !== array.length ? <span>,</span> : null}
                                </div>

                            </div>
                        </>}
                    </>
                ))}
            </div>
        );
    };

    excludeObjectKeys = (key: string) => {
        const excludedKeys = ['compoundType', 'type', 'id1', 'id2', 'source', 'musicDuration', 'productionType', 'productType', 'status', 'productionCategory', 'worksCount', 'isReplaced', 'yearOfProduction', 'episode'];

        if (excludedKeys.includes(key)) {
            return false;
        } else {
            return true;
        }
    }
    renderAddForPackagesStyle = () => {
        return (

            <style>{`
                        .addToPackageCheckmark::before {
                           color: #008f59;
                           border: 1.5px solid #008f59;
                           border-radius: 4px;
                           background-color: #F6F7FA;
                           font-weight: bold;
                           font-size: 12px;
                           padding: 1px;
                        }`
            }
            </style>
        )
    }

    formatWorkTitleWithTypeCode = (title: string, typeCode?: string) => {
        if (!title || !typeCode) {
            return title;
        }
        return `${title} (${typeCode})`;
    }

    renderTitleDiv = () => {
        const { tableContentItem, objectKey, index, componentInstance, renderExpandRow, expandResult, expanded, lookupValues, customer, addToPackages, removeFromPackages, resultPageData } = this.props;
        const { workID,productCoreID,agreementID } = tableContentItem;

        const { tableContentItem: { dataSource }, packageActionsDisabled } = this.props;
        const isRepertoireWork = dataSource === DataSource.Repertoire;
        const titleTypeCodes = Array.isArray(tableContentItem.titleTypeCodes) ? tableContentItem.titleTypeCodes : [];
        const workNameLookups = lookupValues ? getLookupValues(WORK_NAME_LOOKUP, lookupValues) : [];
        const resolveTitleTypeCode = (typeCode?: string) => {
            const typeId = Number(typeCode);
            const matchedLookup = workNameLookups.find((lookup) => lookup.typeID === typeId);
            if (matchedLookup?.code) {
                return matchedLookup.code;
            }
        };
        const formattedTitleValues = Array.isArray(tableContentItem.title)
                ? tableContentItem.title.map((title, titleIndex) =>
                        isRepertoireWork ? this.formatWorkTitleWithTypeCode(title, resolveTitleTypeCode(titleTypeCodes[titleIndex])) : title
                    )
                : [];
        if (objectKey === IP_NAME_NUMBER_STATE_KEY) {
            tableContentItem[objectKey] = RepertoireHelper.zeroPaddedIPINameNumber(tableContentItem[objectKey]);
        }

        if (objectKey === "sourcePool" && Array.isArray(tableContentItem[objectKey])) {
            tableContentItem[objectKey] = tableContentItem[objectKey].join(', ')
        }

        if (componentInstance === "works") {
            if (objectKey !== UPDATE_ACTION_STATE_KEY) {
                let item;
                    if (!this.excludeObjectKeys(objectKey)) {
                        item = tableContentItem[objectKey];
                        if ([SPANISH_POINT_CUSTOMER_NAME, POLARIS_CUSTOMER_NAME, TONO_CUSTOMER_NAME, KODA_CUSTOMER_NAME, TEOSTO_CUSTOMER_NAME].includes(customer)) {
                            item = (objectKey === 'isReplaced' && dataSource === DataSource.Repertoire) ? (item ? 'Replaced' : 'Active') : item;
                        }
                    } else {
                        item = tableContentItem[objectKey] !== undefined ? tableContentItem[objectKey][0] : null;
                    }

                if (objectKey === TITLE_STATE_KEY && item && formattedTitleValues.length > 0) {
                    item = formattedTitleValues[0];
                }

                return (
                  <>
                    <div className="arrowIconDiv">
                      {renderExpandRow && (
                        <img
                          src={RIGHT_ARROW_SVG}
                          title="Expand title"
                          alt="Right Arrow icon"
                          className={
                            expanded ? "arrowIconExpanded" : "arrowIcon"
                          }
                          onClick={() => expandResult(index)}
                        />
                      )}
                      {expanded &&
                      objectKey !== ADD_TO_PACKAGE_ACTION &&
                      this.excludeObjectKeys(objectKey) &&
                      Array.isArray(tableContentItem[objectKey]) &&
                      tableContentItem[objectKey].length > 1 ? (
                                                this.renderMultipleTitlesDiv(
                                                    objectKey === TITLE_STATE_KEY && formattedTitleValues.length > 0
                                                        ? formattedTitleValues
                                                        : tableContentItem[objectKey],
                                                    objectKey,
                                                )
                      ) : (
                        <div className="workTitle">
                          {objectKey === TITLE_STATE_KEY && item ? (
                            <a onClick={this.onClickExternalIcon}>
                              {item.replace(/,\s*$/, "")}
                            </a>
                          ) : item === "" && objectKey === TITLE_STATE_KEY ? (
                            "Title not available"
                          ) : (
                            item
                          )}
                        </div>
                      )}
                    </div>
                    {objectKey === ADD_TO_PACKAGE_ACTION &&
                      dataSource === DataSource.Repertoire &&
                      addToPackages &&
                      resultPageData && (
                        <div
                          className="tableCell specialColumn"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {this.renderAddForPackagesStyle()}
                          <AddToPackageButton
                            key={workID}
                            entityType={EntityType.Work}
                            entityId={workID}
                            addToPackages={addToPackages}
                            removeFromPackages={removeFromPackages}
                            resultPageData={resultPageData}
                            wrapperClassName="workAddtoPackage"
                            disabled={isAddToPackageDisabled({
                              roles: this.props.roles,
                              entityType: EntityType.Work,
                              addToPackages,
                              tableContentItem,
                            })}
                          />
                        </div>
                      )}
                  </>
                );
            } else {
                return (<div></div>);
            }
        }
        else if (componentInstance === null) {
            return (
                <div className="tableCel">
                    {tableContentItem[objectKey]}
                </div>
            );
        }
        else if (componentInstance === "products" || componentInstance === SEARCH_VIEW_REGISTERED_CUE_SHEETS) {
            if (objectKey !== UPDATE_ACTION_STATE_KEY) {
                let item;
                if (!this.excludeObjectKeys(objectKey)) {
                    if (objectKey === PRODUCT_SEARCH_MUSIC_DURATION_KEY) {
                        item = Array.isArray(tableContentItem[objectKey]) && tableContentItem[objectKey][0] ? convertSecondsToTimeStamp(tableContentItem[objectKey][0]) : '';
                    } else {
                        item = tableContentItem[objectKey];
                    }
                }
                else {
                    const value = tableContentItem[objectKey];
                    item = Array.isArray(value) ? value[0] ?? null : value ?? null;
                }

                return (
                  <>
                    <div className="arrowIconDiv">
                      {renderExpandRow && (
                        <img
                          src={RIGHT_ARROW_SVG}
                          title="Expand title"
                          alt="Right Arrow icon"
                          className={
                            expanded ? "arrowIconExpanded" : "arrowIcon"
                          }
                          onClick={() => expandResult(index)}
                        />
                      )}
                      {expanded &&
                      this.excludeObjectKeys(objectKey) &&
                      objectKey !== ADD_TO_PACKAGE_ACTION &&
                      Array.isArray(tableContentItem[objectKey]) &&
                      tableContentItem[objectKey].length > 1 ? (
                        this.renderMultipleTitlesDiv(
                          tableContentItem[objectKey],
                          objectKey,
                        )
                      ) : (
                        <div className="workTitle">
                          {objectKey === TITLE_STATE_KEY && item ? (
                            <a onClick={this.onClickExternalIcon}>
                              {item.replace(/,\s*$/, "")}
                            </a>
                          ) : item === "" && objectKey === TITLE_STATE_KEY ? (
                            "Title not available"
                          ) : (
                            item
                          )}
                        </div>
                      )}
                    </div>
                    {objectKey === ADD_TO_PACKAGE_ACTION &&
                      dataSource === DataSource.Repertoire &&
                      addToPackages &&
                      resultPageData && (
                        <div
                          className="tableCell specialColumn"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {this.renderAddForPackagesStyle()}
                          <AddToPackageButton
                            key={productCoreID}
                            entityType={EntityType.Products}
                            entityId={productCoreID}
                            addToPackages={addToPackages}
                            removeFromPackages={removeFromPackages}
                            resultPageData={resultPageData}
                            wrapperClassName="productsAddtoPackage"
                            disabled={packageActionsDisabled || 
                                isAddToPackageDisabled({
                                roles: this.props.roles,
                                entityType: EntityType.Products,
                                addToPackages,
                                tableContentItem,
                                enforceRole: componentInstance !== SEARCH_VIEW_REGISTERED_CUE_SHEETS,
                            })}
                          />
                        </div>
                      )}
                  </>
                );
            } else {
                return (<div></div>);
            }
        } else if (componentInstance === SEARCH_VIEW_WORKFLOW) {
            if (objectKey === UPDATE_ACTION_STATE_KEY) {
                return (
                    <div className="IconTextButton">
                        <Open16Regular className="icon" onClick={this.onClickExternalIcon} />
                    </div>
                )
            } else {
                if (objectKey === 'dateCreated') {
                    return <div className="arrowIconDiv">
                        <div className="workTitle">
                            <DateDisplay value={tableContentItem[objectKey]} isDateEuropeanFormatFromWorkflows={true} />
                        </div>
                    </div>
                }
                return (
                    <div className="arrowIconDiv">
                        <div className="workTitle">
                            {tableContentItem[objectKey]}
                        </div>
                    </div>
                )
            }
        } else if (componentInstance === SEARCH_VIEW_ARTISTS) {
            return (
                <div className="arrowIconDiv">
                    <div className="workTitle">
                        {tableContentItem[objectKey]}
                    </div>
                    {objectKey === TYPE_STATE_KEY && (
                        <img
                            src={EXTERNAL_BLACK_SVG}
                            title="Open artist in a new tab"
                            alt="External icon"
                            className="externalIcon"
                            onClick={this.onClickExternalIcon}
                        />
                    )}
                </div>
            )
        }
        else if (componentInstance === SEARCH_VIEW_POOLS) {
            return (
                <div className="arrowIconDiv">
                    <div className="workTitle">
                        {(objectKey === POOL_POOL_CODE_STATE_KEY) ? (<a onClick={this.onClickExternalIcon}>{tableContentItem[objectKey]}</a>) : tableContentItem[objectKey]}
                    </div>
                </div>

            )
        }
        else if (componentInstance === SEARCH_VIEW_DISTRIBUTIONS) {
            if (objectKey === USAGE_GROUP_DISTRIBUTION_DATE_STATE_KEY ||
                objectKey === 'lastModifiedDate' ||
                objectKey === 'usageFrom' ||
                objectKey === 'usageTo' ||
                objectKey === 'usageTo' ||
                objectKey === 'createdDate' ||
                objectKey === 'claimsFrom' ||
                objectKey === 'claimsTo') {
                return <div className="arrowIconDiv">
                    <div className="workTitle">
                        <DateDisplay value={tableContentItem[objectKey]} />
                    </div>
                </div>
            }
            if ([DISTRIBUTION_CLAIMS_FROM_STATE_KEY, DISTRIBUTION_CLAIMS_TO_STATE_KEY, DISTRIBUTION_DATE_STATE_KEY, DISTRIBUTION_USAGE_FROM_STATE_KEY, DISTRIBUTION_USAGE_TO_STATE_KEY].includes(objectKey)) {
                if (tableContentItem[objectKey] !== undefined) {
                    const splitString = tableContentItem[objectKey].split('T');
                    return (
                        <div className="arrowIconDiv">
                            <div className="workTitle">
                                {(objectKey === DISTRIBUTION_CODE_STATE_KEY) ? (<a onClick={this.onClickExternalIcon}>{splitString[0] ? splitString[0] : tableContentItem[objectKey]}</a>) : (splitString[0] ? splitString[0] : tableContentItem[objectKey])}
                            </div>
                        </div>
                    )
                }
            } else {
                if (objectKey === DISTRIBUTION_DATE_STATE_KEY) {
                    return <div className="arrowIconDiv">
                        <div className="workTitle">
                            <DateDisplay value={tableContentItem[objectKey]} />
                        </div>
                    </div>
                }

                return (
                    <div className="arrowIconDiv">
                        <div className="workTitle">
                            {(objectKey === DISTRIBUTION_CODE_STATE_KEY) ? (<a onClick={this.onClickExternalIcon}>{tableContentItem[objectKey]}</a>) : tableContentItem[objectKey]}
                        </div>
                    </div>
                )
            }
        }
        else if (componentInstance === SEARCH_VIEW_ADJUSTMENTS) {
            if (objectKey === ADJUSTMENT_DATE_STATE_KEY) {
                return <div className="arrowIconDiv">
                    <div className="workTitle">
                        <DateDisplay value={tableContentItem[objectKey]} />
                    </div>
                </div>
            }
            else if (objectKey === ADJUSTMENT_ID_STATE_KEY) {
                return <div className="workTitle">
                    <a
                        title={tableContentItem[objectKey]}
                        onClick={this.onClickExternalIcon}
                    > 
                        {tableContentItem[objectKey]}
                    </a>
                    </div>
            }
            return (
                <div className="arrowIconDiv">
                    <div className="workTitle">
                        {tableContentItem[objectKey]}
                    </div>
                </div>
            )
        }
        else if (componentInstance === SEARCH_VIEW_LICENSES) {
            return (
                <div className="arrowIconDiv">
                    <div className="workTitle">
                        {tableContentItem[objectKey]}
                    </div>
                    {objectKey === LICENSE_ID_STATE_KEY && (
                        <img
                            src={EXTERNAL_BLACK_SVG}
                            title="Open shopping cart in a new tab"
                            alt="External icon"
                            className="externalIcon"
                            onClick={this.onClickExternalIcon}
                        />
                    )}
                </div>
            )
        }
        else if (componentInstance === SEARCH_VIEW_CLAIMS) {
            return (
                <div className="arrowIconDiv">
                    <div className="workTitle">
                        {tableContentItem[objectKey]}
                    </div>
                    {objectKey === CLAIM_CODE_STATE_KEY && (
                        <img
                            src={EXTERNAL_BLACK_SVG}
                            title="Open Claim in a new tab"
                            alt="External icon"
                            className="externalIcon"
                            onClick={this.onClickExternalIcon}
                        />
                    )}
                </div>
            )
        }
        else if (componentInstance === SEARCH_VIEW_PAYMENTRUN) {
            if (PAYMENTRUN_PAYMENTRUN_DATE_STATE_KEY === objectKey) {
                if (tableContentItem[objectKey] !== undefined) {
                    const splitString = tableContentItem[objectKey].split('T');
                    return (
                        <div className="arrowIconDiv">
                            <div className="workTitle">
                                {splitString[0] ? splitString[0] : tableContentItem[objectKey]}
                            </div>
                        </div>
                    )
                }
            } else {
                return (
                    <div className="arrowIconDiv">
                        <div className="workTitle">
                            {(objectKey === PAYMENTRUN_CODE_STATE_KEY) ? (<a onClick={this.onClickExternalIcon}>{tableContentItem[objectKey]}</a>) : tableContentItem[objectKey]}
                        </div>
                    </div>
                )
            }
        }

        else if (componentInstance === SEARCH_VIEW_DRAFT_SET_LISTS) {
            let item;
            if (!this.excludeObjectKeys(objectKey)) {
                item = tableContentItem[objectKey];
            }
            else if (typeof (tableContentItem[objectKey]) == "string") {
                item = tableContentItem[objectKey] || "";
            }
            else {
                item = (tableContentItem[objectKey] || []).length > 0 ?
                    tableContentItem[objectKey][0].toString() || "" : "";
            }

            let onExpandResult = () => {
                expandResult(index);
            }

            const value = tableContentItem[objectKey];
            const isArray = Array.isArray(value);
            const canExpand = isArray && value.length > 1;

            return (
                <div className="arrowIconDiv">
                    {renderExpandRow && canExpand && (
                        <img
                            src={RIGHT_ARROW_SVG}
                            title="Expand title"
                            alt="Right Arrow icon"
                            className={expanded ? "arrowIconExpanded" : "arrowIcon"}
                            onClick={() => onExpandResult()}
                        />
                    )}
                    {expanded &&
                        (this.excludeObjectKeys(objectKey) &&
                            typeof (tableContentItem[objectKey]) != "string" &&
                            (tableContentItem[objectKey] || []).length > 1) ?
                        (
                            this.renderMultipleTitlesDiv(tableContentItem[objectKey])
                        ) :
                        (
                            <div className="workTitle">
                                {item ? item.replace(/,\s*$/, "") : item}
                            </div>
                        )
                    }
                    {objectKey === DRAFT_WORKS_RESULTS_TITLE_STATE_KEY && (
                        <img
                            src={EXTERNAL_SVG}
                            // TODO: EB 2023/04/07. Change the title for this icon
                            // for registered works.
                            title="Open details in a new tab"
                            alt="External icon"
                            className="externalIcon"
                            onClick={this.onClickExternalIcon}
                        />
                    )}
                </div>
            )
        }

        else if (componentInstance === SEARCH_VIEW_LIVE_PERFORMANCE_SUBMISSION) {
            return (
                <div className="arrowIconDiv">
                    {
                        <div className="tableCel">
                            {tableContentItem[objectKey]}
                        </div>
                    }
                    {objectKey === "performanceDate" && (
                        <img
                            src={EXTERNAL_SVG}
                            title="Open Live Performance in a new tab"
                            alt="External icon"
                            className="externalIcon"
                            onClick={this.onClickExternalIcon}
                        />
                    )}
                </div>
            )
        }


        else if (componentInstance === SEARCH_VIEW_DRAFT_WORKS) {
            let item;
            if (!this.excludeObjectKeys(objectKey)) {
                item = tableContentItem[objectKey];
            }
            else if (typeof (tableContentItem[objectKey]) == "string") {
                item = tableContentItem[objectKey] || "";
            }
            else {
                item = (tableContentItem[objectKey] || []).length > 0 ?
                    tableContentItem[objectKey][0].toString() || "" : "";
            }

            let onExpandResult = () => {
                expandResult(index);
            }

            return (
                <div className="arrowIconDiv">
                    {renderExpandRow && (
                        <img
                            src={RIGHT_ARROW_SVG}
                            title="Expand title"
                            alt="Right Arrow icon"
                            className={expanded ? "arrowIconExpanded" : "arrowIcon"}
                            onClick={() => onExpandResult()}
                        />
                    )}
                    {expanded &&
                        (this.excludeObjectKeys(objectKey) &&
                            typeof (tableContentItem[objectKey]) != "string" &&
                            (tableContentItem[objectKey] || []).length > 1) ?
                        (
                            this.renderMultipleTitlesDiv(tableContentItem[objectKey])
                        ) :
                        (
                            <div className="workTitle">
                                {item ? item.replace(/,\s*$/, "") : item}
                            </div>
                        )
                    }
                    {objectKey === DRAFT_WORKS_RESULTS_TITLE_STATE_KEY && (
                        <img
                            src={EXTERNAL_BLACK_SVG}
                            // TODO: EB 2023/04/07. Change the title for this icon
                            // for registered works.
                            title="Open Draft Work in a new tab"
                            alt="External icon"
                            className="externalIcon"
                            onClick={this.onClickExternalIcon}
                        />
                    )}

                {(objectKey === ADD_TO_PACKAGE_ACTION && dataSource === DataSource.Repertoire && addToPackages && resultPageData &&
                        <div className="tableCell specialColumn" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            {this.renderAddForPackagesStyle()}
                            <AddToPackageButton
                                key={workID}
                                entityType={EntityType.Work}
                                entityId={workID}
                                addToPackages={addToPackages}
                                resultPageData={resultPageData}
                                wrapperClassName="workAddtoPackage"
                                disabled={false}
                            />
                        </div>
                    )}
                </div>
            )
        }
        else {
            if (objectKey === IP_EFFECTIVE_FROM_KEY || objectKey === IP_EFFECTIVE_TO_KEY) {
                return <div className="arrowIconDiv">
                    <div className="workTitle">
                        <DateDisplay value={tableContentItem[objectKey]} showTime={false} />
                    </div>
                </div>
            }
            return (
              <>
                <div className="arrowIconDiv">
                  <div className="workTitle">
                    {objectKey === REGION_STATE_KEY &&
                      tableContentItem.worldExcluding == true &&
                      "World Excluding: "}
                    {tableContentItem[objectKey]}
                  </div>
                  {objectKey === IP_NAME_NUMBER_STATE_KEY && (
                    <img
                      src={EXTERNAL_BLACK_SVG}
                      title={
                        componentInstance === "ips"
                          ? "Open ip in a new tab"
                          : "Open agreement in a new tab"
                      }
                      alt="External icon"
                      className="externalIcon"
                      onClick={this.onClickExternalIcon}
                    />
                  )}
                </div>
                {objectKey === ADD_TO_PACKAGE_ACTION &&
                  dataSource === DataSource.Repertoire &&
                  addToPackages &&
                  resultPageData && (
                    <div
                      className="tableCell specialColumn"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {this.renderAddForPackagesStyle()}
                      <AddToPackageButton
                        key={agreementID}
                        entityType={EntityType.Agreements}
                        entityId={agreementID}
                        addToPackages={addToPackages}
                        resultPageData={resultPageData}
                        wrapperClassName="agreementAddtoPackage"
                        disabled={isAddToPackageDisabled({
                          roles: this.props.roles,
                          entityType: EntityType.Agreements,
                          addToPackages,
                          tableContentItem,
                        })}
                      />
                    </div>
                  )}
              </>
            );
        }
    };

    render() {
        const { objectKey } = this.props;
        return <div className="tableCell">{this.renderTitleDiv()}</div>;
    }
}
